import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SEO } from './components/SEO';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { WeddingsPricing } from './pages/WeddingsPricing';
export function App() {
  return <HelmetProvider data-id="element-0">
      <SEO data-id="element-1" />
      <BrowserRouter data-id="element-2">
        <div className="min-h-screen bg-charcoal text-white font-sans selection:bg-copper/30 selection:text-white" data-id="element-3">
          <Navbar data-id="element-4" />
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/weddings-pricing" element={<WeddingsPricing data-id="element-9" />} data-id="element-8" />
          </Routes>
          <Footer data-id="element-10" />
        </div>
      </BrowserRouter>
    </HelmetProvider>;
}